<template>
	<div class="loader"></div>
</template>

<script>
export default {
	name: 'loader'
}	
</script>


// WEBPACK FOOTER //
// Loader.vue?095c1ddc